export const hubPricingFeaturesI18Nkeys = {
  marketing: {
    free: ['emailMarketing', 'forms', 'landingPages', 'liveChat', 'contactManagement', 'socialAds'],
    starter: ['everythingFree', 'formEmails', 'retargeting', 'landingPageReporting', 'multipleCurrencies', 'hubspotBrandingRemoved'],
    pro: ['everythingStarter', 'marketingAutomation', 'seo', 'blog', 'socialMedia', 'customReporting'],
    enterprise: ['everythingPro', 'accountBasedMarketing', 'adaptiveTesting', 'predictiveLeadScoring', 'userRoles', 'revenueAttribution']
  },
  sales: {
    free: ['contactManagement', 'dealPipeline', 'quotes', 'meetingScheduling', 'liveChat', 'reportingDashboard'],
    starter: ['everythingFree', 'simpleAutomation', 'goals', 'conversationRouting', 'multipleCurrencies', 'repPerformance'],
    pro: ['everythingStarter', 'sequences', 'teams', 'customReporting', 'phoneSupport', 'automation'],
    enterprise: ['everythingPro', 'customObjects', 'predictiveLeadScoring', 'playbooks', 'forecasting', 'revenueTracking']
  },
  service: {
    free: ['contactManagement', 'ticketing', 'liveChat', 'teamEmail', 'ticketsClosedReports', 'reportingDashboard'],
    starter: ['everythingFree', 'conversationRouting', 'simpleAutomation', 'multipleTicketPipelines', 'multipleCurrencies', 'callingSdk'],
    pro: ['everythingStarter', 'knowledgeBase', 'customerFeedbackSurveys', 'helpDeskAutomation', 'videoCreation', 'visitorId'],
    enterprise: ['everythingPro', 'goals', 'playbooks', 'sso', 'userRoles', 'teamManagement']
  }
};
export const currencies = ['USD', 'EUR', 'GBP', 'AUD', 'JPY', 'SGD', 'COP'];